import API from 'services/api'
export default class Teachers extends API {
	async getTeachers({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		filter,
	}) {
		onStart()
		const { page, page_size, search } = filter
		try {
			const options = {
				url: `/admin/teacher/
				${page ? `?page=${page}` : ''}
				${page_size ? `&page_size=${page_size}` : ''}
				${search ? `&search=${search}` : ''}`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async createTeachers({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		try {
			const options = {
				method: 'POST',
				url: `/admin/teacher/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async updateTeachers({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		const { id } = data
		try {
			const options = {
				method: 'PUT',
				url: `/admin/teacher/${id}/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async deleteTeachers({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'DELETE',
				url: `/admin/teacher/${id}/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
}
